import { Avatar, Box, Button, Typography } from "@mui/material";
import { ServicesFolderIcon } from "src/Icons/ServicesFolderIcon";

import { NewCategoryCardProps } from "./NewCategoryCard.types";

export function NewCategoryCard ({ onClick }: NewCategoryCardProps) {
  return (
    <Button
      sx={{
        "&": {
          padding: 0,
          margin: "0px 24px 24px 0px",
        },
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          border: "1px dashed #EE9DB9",
          backgroundColor: "#FFFFFF",
          borderRadius: "6px",
          padding: "10px",
          width: "374px",
          cursor: "pointer",
        }}
      >
        <Avatar
          variant="rounded"
          sx={{
            width: "88px",
            height: "88px",
            borderRadius: "6px",
            backgroundColor: "#FFF8FA",
          }}
        >
          <ServicesFolderIcon
            sx={{
              fontSize: "45px",
              color: "#EE9DB9",
            }}
          />
        </Avatar>
        <Box
          sx={{
            marginLeft: "16px",
            display: "flex",
            justifyContent: "space-between",
            flex: 1,
          }}
        >
          <Typography
            sx={{
              fontWeight: "500",
              textTransform: "uppercase",
              color: "#BF295C",
            }}
          >
            add new category
          </Typography>
        </Box>
      </Box>
    </Button>
  );
}
